// Active campaign forms
'use strict';
var twentyninetimes = twentyninetimes || {};
const acForms = document.querySelectorAll('._form');

twentyninetimes.acForms = twentyninetimes.acForms || function () {

	function init() {
        //Set unique IDs for each form input and label
        acForms.forEach(function (form) {
            let formId = form.getAttribute('id');
            let formInputs = form.querySelectorAll('input');
            let formLabels = form.querySelectorAll('label');
            formInputs.forEach(function (input) {
                input.setAttribute('id', formId + '_' + input.getAttribute('name'));
            });
            formLabels.forEach(function (label) {
                label.setAttribute('for', formId + '_' + label.getAttribute('for'));
            });
        }
        );

        //All input fields with a data-name that has an anchestor with a class containing "_form_element" Add a class with the data-name to the anchestor
        const dataNameElements = document.querySelectorAll('[data-name]');
        dataNameElements.forEach(function (element) {
            let elementParent = element.closest('._form_element');

            if(elementParent != null) {
                elementParent.classList.add(element.getAttribute('data-name'));
            }
        }
        );

            //get all input fields inside _form_element and add a class to its label when it has a value
            const formInputElements = document.querySelectorAll('._form_element input, ._form_element textarea, ._form_element select');
            formInputElements.forEach(function (element) {
                let elementParent = element.closest('._form_element');
                let elementLabel = elementParent.querySelector('label');

                if(elementLabel != null) {
                    element.addEventListener('change', function () {
                        console.log('change', element.parentNode.parentNode.querySelector('._form-label'), element.value);
                        if(element.value != '') {
                            elementLabel.classList.add('has_value');
                        } else {
                            elementLabel.classList.remove('has_value');
                        }
                    }
                    );
                }
            }
        );
	}

	return {
		init : init
	};

}();